module.exports = __webpack_public_path__ + "media/images/chambres fumeurs disponibles-4314bab8a975ee35bf23860fd5d5d1c2.svg";